import { SERVER_API } from '@/utils/constant';

export default {
    icon: "el-icon-time",
    title: "秒杀",
    name: "seckill",
    timestamp: "1709627778508009",
    setUp: {
        tabVal: 1
    },
    countDownColor: {
        title: "倒计时背景色",
        name: "countDownColor",
        default: [
            {
                item: "rgba(252,60,62,0.09)"
            }
        ],
        color: [
            {
                item: "rgba(252,60,62,0.09)"
            }
        ]
    },
    themeColor: {
        title: "主题风格",
        name: "themeColor",
        default: [
            {
                item: "#E93323"
            }
        ],
        color: [
            {
                item: "#E93323"
            }
        ]
    },
    conStyle: {
        title: "背景样式",
        name: "conStyle",
        type: 1,
        list: [
            {
                val: "直角",
                icon: 'el-icon-edit-outline'
            },
            {
                val: "圆角",
                icon: 'el-icon-c-scale-to-original'
            }
        ]
    },
    bgColor: {
        title: "背景颜色",
        name: "themeColor",
        default: [
            {
                item: "#fff"
            }
        ],
        color: [
            {
                item: "#fff"
            }
        ]
    },
    prConfig: {
        title: "背景边距",
        val: 10,
        min: 0
    },
    priceShow: {
        title: "是否显示价格",
        val: true
    },
    discountShow: {
        title: "是否显示折扣标签",
        val: true
    },
    titleShow: {
        title: "是否显示名称",
        val: true
    },
    seckillShow: {
        title: "抢购标签",
        val: true
    },
    numberConfig: {
        val: 3
    },
    lrConfig: {
        title: "左右边距",
        val: 10,
        min: 0
    },
    mbConfig: {
        title: "页面间距",
        val: 10,
        min: 0
    },
    imgConfig: {
        title: "最多可添加1张图片，建议宽度18 * 18px",
        url: SERVER_API + "/images/decoration/hot.png"
    },
    id: "id1709627778508009"
}